// The existing service-area page lists these cities. These are service areas,
// not additional office locations; availability is confirmed for each enquiry.
export const SERVICE_CITIES = ["Bhopal", "Indore", "Jabalpur", "Gwalior", "Satna", "Rewa", "Ujjain"];

// Administrative coverage, not branch offices. Names checked against the
// National Portal of India; individual service availability is reviewed.
export const INDIA_STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
  "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
  "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
  "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
];
export const INDIA_UNION_TERRITORIES = [
  "Andaman and Nicobar Islands", "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi", "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry",
];
export const INDIA_REGIONS = [...INDIA_STATES, ...INDIA_UNION_TERRITORIES];
export const isIndiaRegion = (value) => INDIA_REGIONS.includes(value);

export const cityAnchor = (city) => city.toLowerCase().replace(/\s+/g, "-");

export function serviceAreasSchema() {
  return [
    { "@type": "Country", name: "India" },
    { "@type": "State", name: "Madhya Pradesh" },
    ...SERVICE_CITIES.map((name) => ({
      "@type": "City", name,
      containedInPlace: { "@type": "State", name: "Madhya Pradesh" },
    })),
  ];
}
